import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const TaskBulkTaskGroupCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedTaskCount = 0, taskBulkTaskGroupOptions = [] } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set task group for ${selectedTaskCount} ${pluralize("task", selectedTaskCount)}`}
            options={taskBulkTaskGroupOptions}
        />
    );
};
